export default __webpack_public_path__ + "media/images/mailer/icon_lock_open-e23a5d046869b0648523e7ffd6837c10.png";